import { render, staticRenderFns } from "./activeOption.vue?vue&type=template&id=392a6bde&scoped=true"
import script from "./activeOption.vue?vue&type=script&lang=js"
export * from "./activeOption.vue?vue&type=script&lang=js"
import style0 from "./activeOption.vue?vue&type=style&index=0&id=392a6bde&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "392a6bde",
  null
  
)

export default component.exports